import React, { useState, useRef } from 'react'
import { IkonContainerNotater } from '../../../../assets/icons'
import { CardColumn } from '../../../ui/Card/CardColumn'
import { CaseDetail } from '../../../../models/CaseDetail'
import { formatDate } from '../../../../utils/format'
import { Typography } from '../../../ui/Typography/Typography'
import CreateNoteOverlay from './CreateNoteOverlay'
import CaseNotesOverlay, { CaseNotesOverlayRef } from './CaseNotesOverlay'
import { colors } from '../../../../theme/palette'
import { Button } from '../../../ui/Button/Button'
import { L } from '../../../providers/Lokalise'

const CaseNotesRow: React.FC<{
    caseDetails: CaseDetail
    onUpdated: () => void
}> = ({ caseDetails, onUpdated }) => {
    const [showAllNotes, setShowAllNotes] = useState(false)
    const overlayRef = useRef<CaseNotesOverlayRef>(null)

    return (
        <CardColumn
            titleLabel={L('LØN_NOTATER_CONTAINER_TITLE')}
            titleIcon={<IkonContainerNotater fill={colors.green} />}
            rows={[
                {
                    label: '',
                    value: '',
                    useContent: true,
                    content: (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '0.7rem',
                                overflow: 'hidden',
                                width: '100%',
                            }}
                        >
                            <CreateNoteOverlay
                                caseDetails={caseDetails}
                                onUpdated={onUpdated}
                            />
                            <div style={{ position: 'relative' }}>
                                {caseDetails?.noteList
                                    .slice(0, showAllNotes ? undefined : 4)
                                    .map((note, index) => (
                                        <Button
                                            key={note.id}
                                            type="ghost"
                                            onClick={() =>
                                                overlayRef.current?.openOverlay(
                                                    note.id
                                                )
                                            }
                                            style={{
                                                marginBottom: '.7rem',
                                                opacity:
                                                    !showAllNotes && index === 3
                                                        ? 0.3
                                                        : 1,
                                                position: 'relative',
                                                ...(index === 3 &&
                                                    !showAllNotes && {
                                                        maxHeight: '2.5rem',
                                                        overflow: 'hidden',
                                                        background:
                                                            'linear-gradient(to bottom, rgba(255,255,255,1) 0%, rgba(255,255,255,0.3) 100%)',
                                                    }),
                                            }}
                                        >
                                            <Typography
                                                tag="p"
                                                size="XXS"
                                                style={{
                                                    overflow: 'hidden',
                                                    textOverflow: 'clip',
                                                    whiteSpace: 'nowrap',
                                                }}
                                            >
                                                <span
                                                    style={{
                                                        marginRight: '0.5rem',
                                                        color: colors.gray800,
                                                    }}
                                                >
                                                    {formatDate(
                                                        new Date(note.createdAt)
                                                    )}
                                                </span>
                                                <span
                                                    style={{
                                                        fontSize: '.9rem',
                                                        color: colors.black,
                                                    }}
                                                >
                                                    {note.message}
                                                </span>
                                            </Typography>
                                        </Button>
                                    ))}
                            </div>
                            {caseDetails?.noteList.length > 0 && (
                                <div
                                    style={{
                                        position: 'relative',
                                        zIndex: 2,
                                        backgroundColor: 'white',
                                        top: '-.8rem',
                                        width: '100%',
                                    }}
                                >
                                    <CaseNotesOverlay
                                        ref={overlayRef}
                                        caseDetails={caseDetails}
                                        onUpdated={onUpdated}
                                    />
                                </div>
                            )}
                        </div>
                    ),
                },
            ]}
        />
    )
}

export { CaseNotesRow }
